export default __webpack_public_path__ + "static/illustration-6dbdba95246a1207520a3a335c36a89e.svg";